<div class="step-box">
    <div class="row">
        <span jhiTranslate="head-to-head-query.select.entries.label"></span>
    </div>
    <div class="row pt-2">
        <div class="row mt-2">
            <section class="col-md-6">
                <jhi-specify-entries-tab [isForTestEntries]="true"></jhi-specify-entries-tab>
            </section>
            <section class="col-md-6">
                <jhi-specify-entries-tab [isForTestEntries]="false"></jhi-specify-entries-tab>
            </section>
        </div>
        <div class="row mt-2 mb-2">
            <div class="col-8">
                <div class="mb-3 d-flex align-items-center">
                    <jhi-item-count [page]="page" [total]="totalItems" [itemsPerPage]="itemsPerPage"></jhi-item-count>
                    <div class="p-2">
                        <span>{{'global.selected' | translate}}:</span>
                        <span class="fw-bold pl-2">
                            {{ isSelectAll ? totalItems : selectedItems.size }}
                        </span>
                    </div>
                    <div class="form-check form-check-inline pl-5">
                        <input (click)="onSelectAll(isSelectAll)" [checked]="isSelectAll" class="form-check-input" id="check-select-all" name="check-select-all" [ngbTooltip]="'global.select.all' | translate" type="checkbox">
                        <label class="form-check-label pl-2" for="check-select-all" jhiTranslate="global.select.all">
                            Select all pages
                        </label>
                    </div>
                    <div class="ms-2" style="margin-left: 10px;">
                        <button class="btn btn-sm btn-outline-info" (click)="onClearSort($event)" jhiTranslate="global.clear-sort"></button>
                    </div>
                    <span *ngIf="isLoading" class="throbber ms-2"></span>
                </div>
            </div>
        </div>
        <div class="table-responsive custom-scroll-style" style="height: auto; overflow: auto">
            <table class="table table-striped table-curved table-bordered" *ngIf="germplasmPairs.length else nodata">
                <thead class="sticky-header">
                <tr jhiSort [(predicate)]="predicate" [(ascending)]="isAscending" [callback]="sort.bind(this)">
                    <th style="width: 30px"><input type="checkbox" class="form-check-input" [ngbTooltip]="'global.select.current.page' | translate" [checked]="isPageSelected()" (click)="onSelectPage()"></th>
                    <th [jhiSortBy]="ColumnHeaders.TEST_GROUP_ID"><span jhiTranslate="head-to-head-query.column.header.group.id">GROUP ID</span> <span class="fa fa-sort"></span></th>
                    <th [jhiSortBy]="ColumnHeaders.TEST_GID"><span jhiTranslate="head-to-head-query.column.header.test.gid">GID TEST</span> <span class="fa fa-sort"></span></th>
                    <th [jhiSortBy]="ColumnHeaders.TEST_DESIG" *jhiHasAnyAuthority="VIEW_NAMES_PERMISSIONS"><span jhiTranslate="head-to-head-query.column.header.test.desig">TEST ENTRY DESIGNATION</span> <span class="fa fa-sort"></span></th>
                    <th [jhiSortBy]="ColumnHeaders.STANDARD_GROUP_ID"><span jhiTranslate="head-to-head-query.column.header.group.id">GROUP ID</span> <span class="fa fa-sort"></span></th>
                    <th [jhiSortBy]="ColumnHeaders.STANDARD_GID"><span jhiTranslate="head-to-head-query.column.header.standard.gid">GID STANDARD</span> <span class="fa fa-sort"></span></th>
                    <th [jhiSortBy]="ColumnHeaders.STANDARD_DESIG" *jhiHasAnyAuthority="VIEW_NAMES_PERMISSIONS"><span jhiTranslate="head-to-head-query.column.header.standard.desig">STANDARD ENTRY DESIGNATION</span> <span class="fa fa-sort"></span></th>
                </tr>
                </thead>
                <tbody *ngIf="germplasmPairs.length">
                <tr *ngFor="let entry of pagedData; trackBy: trackId; index as index"
                    (click)="toggleSelect($event, index, entry); $event.stopPropagation()"
                    [class.selected]="isSelected(entry)"
                    (mousedown)="$event.preventDefault()"
                    #p="ngbPopover"
                    (contextmenu)="showRightClickMenu($event, p)"
                    [autoClose]="true"
                    [triggers]="'manual'"
                    [ngbPopover]="cellContextMenu">
                    <td><input type="checkbox" class="form-check-input" [checked]="isSelected(entry)" (click)="toggleSelect($event, index, entry, true); $event.stopPropagation()"></td>
                    <td>{{ entry.testGroupId ? entry.testGroupId : '-' }}</td>
                    <td>
                        <a class="link" (click)="germplasmDetailsPopupService.open(entry.testGID)">
                            <truncate-span [textInput]="entry.testGID">
                            </truncate-span>
                        </a>
                    </td>
                    <td *jhiHasAnyAuthority="VIEW_NAMES_PERMISSIONS">
                        <a class="link" (click)="germplasmDetailsPopupService.open(entry.testGID)">
                            <truncate-span [textInput]="entry.testDesignation" [maxLength]="MAX_NAME_DISPLAY_SIZE">
                            </truncate-span>
                        </a>
                    </td>
                    <td>{{ entry.standardGroupId ? entry.standardGroupId : '-' }}</td>
                    <td>
                        <a class="link" (click)="germplasmDetailsPopupService.open(entry.standardGID)">
                            <truncate-span [textInput]="entry.standardGID">
                            </truncate-span>
                        </a>
                    </td>
                    <td *jhiHasAnyAuthority="VIEW_NAMES_PERMISSIONS">
                        <a class="link" (click)="germplasmDetailsPopupService.open(entry.standardGID)">
                            <truncate-span [textInput]="entry.standardDesignation" [maxLength]="MAX_NAME_DISPLAY_SIZE">
                            </truncate-span>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
            <ng-template #nodata>
                <table class="table table-striped table-bordered table-curved">
                    <thead><tr><th></th></tr></thead><tbody>
                <tr><td jhiTranslate="no.data"></td></tr></tbody>
                </table>
            </ng-template>
        </div>
        <div *ngIf="germplasmPairs && germplasmPairs.length">
            <div class="row">
                <div class="col">
                    <div class="pagination-container">
                        <div class="pagination-box pagination-box-left">
                            <div>
                                <jhi-item-count [page]="page" [total]="totalItems" [itemsPerPage]="itemsPerPage"></jhi-item-count>
                            </div>
                        </div>
                        <div class="pagination-box">
                            <ngb-pagination [collectionSize]="totalItems" [(page)]="page" [pageSize]="itemsPerPage" [disabled]="isLoading"
                                            [maxSize]="5" [rotate]="true" [boundaryLinks]="true" (pageChange)="loadPage(page)"></ngb-pagination>
                        </div>
                        <div class="pagination-box pagination-box-right">
                            <div class="d-flex align-items-center">
                                <label for="itemsPerPage" class="control-label control-label-left" jhiTranslate="global.items.per.page"></label>
                                <select [(ngModel)]="itemsPerPage" class="form-select ms-2" id="itemsPerPage" [disabled]="isLoading" (change)="resetTable();" style="width:95px">
                                    <option value="20">20</option>
                                    <option value="50">50</option>
                                    <option value="75">75</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12 text-center">
            <button class="btn btn-primary ms-2" [disabled]="disableNextStep()" (click)="nextStep()">
                <span jhiTranslate="next"></span>
            </button>
        </div>
    </div>
</div>

<ng-template #cellContextMenu>
    <div class="p-2">
        <button class="btn btn-sm btn-outline-info w-100" type="submit" (click)="selectAll()" jhiTranslate="head-to-head-query.actions.select.all">
        </button>
        <button class="btn btn-sm mt-2 btn-outline-info w-100" type="submit" (click)="removeSelected()" jhiTranslate="head-to-head-query.actions.delete.selected">
        </button>
    </div>
</ng-template>
